<div
  [ngClass]="{
    'min-h-screen bg-base-100 dark:bg-textbox-fill': !isDialog,
    'bg-transparent': isDialog
  }"
>
  @if (!isDialog) {
    <app-navbar />
  }
  <main
    [ngClass]="
      isDialog
        ? 'max-h-[calc(100vh-120px)] overflow-y-auto px-6 py-6 sm:px-8 lg:px-10'
        : 'px-4 py-6 lg:px-12'
    "
  >
    <div
      class="flex flex-col items-center mx-auto px-0"
      [ngClass]="isDialog ? 'mt-0' : 'mt-6 lg:mt-20'"
    >
      @if (isDialog) {
        <div
          class="mb-8 flex w-full items-start justify-between gap-4 border-b border-textbox-border pb-6"
        >
          <div>
            <p class="inter-600 text-xs uppercase tracking-[0.18em] text-kek-purple mb-2">
              Start questionnaire
            </p>
            <h1 class="space-grotesk-600 text-[2rem] leading-tight text-support-text">
              Questionnaire setup
            </h1>
          </div>
          <button
            type="button"
            (click)="cancel()"
            class="flex h-10 w-10 items-center justify-center rounded-full border border-nav-btn-border text-nav-btn-text transition-colors hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text"
            aria-label="Close questionnaire setup"
          >
            <span class="material-symbols-outlined text-[1.25rem]">close</span>
          </button>
        </div>
      }


      <div
        class="panels-viewport w-full"
        [class.panels-viewport--expanded]="showRespondentPanel"
      >
        <div class="panels-row">


          <div class="panel flex flex-col">

            <div
              class="flex-1 rounded-[10px] border border-textbox-border bg-surface-background p-6 lg:p-8"
            >
              <h1 class="space-grotesk-600 text-[27px] text-left mb-6 text-support-text">
                {{ isDialog ? 'Questionnaire' : 'Questionnaire Details' }}
              </h1>

          <!-- Select Questionnaire -->
          <div class="mb-6">
            <h3 class="inter-700 text-[18px] mb-3 text-support-text">Select Questionnaire</h3>
            <div class="relative">
              <button
                type="button"
                class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 pr-10 text-left flex items-center justify-between"
                (click)="questionnaireDropdownOpen.set(!questionnaireDropdownOpen())"
                data-testid="questionnaire-select-button"
              >
                <span>{{ getSelectedQuestionnaireName() }}</span>
                <span class="material-symbols-outlined text-base-200">arrow_drop_down</span>
              </button>
              @if (questionnaireDropdownOpen()) {
                <ul
                  class="absolute z-10 bg-neutral w-full mt-1 max-h-60 overflow-auto rounded-lg shadow-lg border border-textbox-border"
                  data-testid="questionnaire-select-options"
                >
                  @for (questionnaire of availableQuestionnaires; track questionnaire) {
                    <li
                      class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                      (click)="selectedQuestionnaireGuid = questionnaire.guid; questionnaireDropdownOpen.set(false); updateDetailsForm()"
                    >
                      {{ questionnaire.name }}
                    </li>
                  }
                </ul>
              }
            </div>
          </div>

          <!-- Respondent -->
          <div class="mb-6 min-h-[140px]">
            <h3 class="inter-700 text-[18px] mb-3 text-support-text">Respondent</h3>
            <div class="relative">
              <button
                type="button"
                class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 pr-10 text-left flex items-center justify-between"
                (click)="respondentTypeDropdownOpen.set(!respondentTypeDropdownOpen())"
                data-testid="respondent-type-button"
              >
                <span>{{ getRespondentTypeLabel() }}</span>
                <span class="material-symbols-outlined text-base-200">arrow_drop_down</span>
              </button>
              @if (respondentTypeDropdownOpen()) {
                <ul
                  class="absolute z-10 bg-neutral w-full mt-1 max-h-60 overflow-auto rounded-lg shadow-lg border border-textbox-border"
                  data-testid="respondent-type-options"
                >
                  <li
                    class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                    (click)="setRespondentType(SurveyRespondentType.Anonymous); existingRespondentGuid = undefined; searchText.set(''); isEditingRespondent.set(false); respondentTypeDropdownOpen.set(false)"
                  >
                    Anonymous
                  </li>
                  <li
                    class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                    (click)="setRespondentType(SurveyRespondentType.Existing); existingRespondentGuid = undefined; searchText.set(''); isEditingRespondent.set(false); respondentTypeDropdownOpen.set(false)"
                  >
                    Existing
                  </li>
                  <li
                    class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                    (click)="setRespondentType(SurveyRespondentType.New); existingRespondentGuid = undefined; searchText.set(''); isEditingRespondent.set(false); respondentTypeDropdownOpen.set(false)"
                  >
                    New
                  </li>
                </ul>
              }
            </div>

            <!-- Existing respondent search -->
            @if (surveyRespondentType === SurveyRespondentType.Existing) {
              <div class="relative mt-4">
                <input
                  type="text"
                  class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 pr-10"
                  [value]="searchText()"
                  (input)="onSearchInput($event)"
                  (focus)="dropdownOpen.set(true)"
                  autocomplete="off"
                  placeholder="Search existing respondent..."
                />
                <button
                  type="button"
                  class="absolute right-10 top-1/2 -translate-y-1/2 cursor-pointer"
                  (click)="dropdownOpen.set(!dropdownOpen())"
                  tabindex="-1"
                >
                <span class="material-symbols-outlined text-base-200">arrow_drop_down</span>
                </button>
                @if (dropdownOpen()) {
                  <ul class="absolute z-10 bg-neutral w-full mt-1 max-h-60 overflow-auto rounded-lg shadow-lg border border-textbox-border">
                    @for (respondent of filteredRespondents(); track respondent.guid) {
                      <li
                        class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                        (click)="existingRespondentGuid = respondent.guid; searchText.set(getFormattedRespondentName(respondent)); dropdownOpen.set(false); prefillFormWithExistingRespondent(); preFillInviteRespondentField()"
                      >
                        {{ getFormattedRespondentName(respondent) }}
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </div>

          <!-- Completion -->
          <div class="mb-6">
            <h3 class="inter-700 text-[18px] mb-3 text-support-text">Completion</h3>
            <div class="relative">
              <button
                type="button"
                class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 pr-10 text-left flex items-center justify-between"
                (click)="completionDropdownOpen.set(!completionDropdownOpen())"
                data-testid="completion-type-button"
              >
                <span>{{ getCompletionLabel() }}</span>
                <span class="material-symbols-outlined text-base-200">arrow_drop_down</span>
              </button>
              @if (completionDropdownOpen()) {
                <ul
                  class="absolute bottom-full z-30 bg-neutral w-full mb-1 max-h-60 overflow-auto rounded-lg shadow-lg border border-textbox-border"
                  data-testid="completion-type-options"
                >
                  <li
                    class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                    (click)="selectedDispatchType = ''; completionDropdownOpen.set(false); onInviteLinkDispatchTypeChanged()"
                  >
                    Do on this device
                  </li>
                  @for (inviteLinkType of InviteLinkDispatchType | keyvalue: unsorted; track inviteLinkType) {
                    <li
                      class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                      (click)="selectedDispatchType = inviteLinkType.value; completionDropdownOpen.set(false); onInviteLinkDispatchTypeChanged()"
                    >
                      {{ inviteLinkType.key | camelCaseSplit }}
                    </li>
                  }
                </ul>
              }
            </div>

            <!-- Email input for anonymous + email dispatch -->
            @if (selectedDispatchType === InviteLinkDispatchType.Email && surveyRespondentType === SurveyRespondentType.Anonymous) {
              <input
                [(ngModel)]="inviteeEmailAddress"
                type="email"
                placeholder="Invitee Email"
                class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 mt-4"
              />
            }

            <!-- Mobile input for anonymous + text dispatch -->
            @if (selectedDispatchType === InviteLinkDispatchType.TextMessage && surveyRespondentType === SurveyRespondentType.Anonymous) {
              <input
                [(ngModel)]="inviteeMobileNumber"
                type="text"
                placeholder="Invitee Mobile Number"
                class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 mt-4"
              />
            }

            @if (selectedDispatchType === InviteLinkDispatchType.SocialMedia || selectedDispatchType === InviteLinkDispatchType.Website) {
              <p class="inter-400 text-sm text-base-200 mt-2">
                {{ selectedDispatchType | camelCaseSplit | titlecase }} dispatch type coming soon!
              </p>
            }
          </div>

          <!-- Additional Details (questionnaire-specific form fields) -->
          @if (Object.keys(detailsForm.controls).length > 0) {
            <div class="mb-6">
              <h3 class="inter-700 text-[18px] mb-3 text-support-text">Additional Details</h3>
              <form [formGroup]="detailsForm" class="grid gap-4">
                @for (formControl of detailsForm.controls | keyvalue: unsorted; track formControl) {
                  <div>
                    <label class="inter-400 text-sm mb-1 block text-support-text">{{ formControl.key }}</label>
                    @if (getDetailsFormFieldType(formControl.key) === QuestionType.FreeText) {
                      <input
                        formControlName="{{ formControl.key }}"
                        type="text"
                        class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400"
                      />
                    }
                    @if (getDetailsFormFieldType(formControl.key) === QuestionType.Date) {
                      <input
                        formControlName="{{ formControl.key }}"
                        type="date"
                        class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400"
                      />
                    }
                    @if (getDetailsFormFieldType(formControl.key) === QuestionType.SingleChoice) {
                      <select
                        formControlName="{{ formControl.key }}"
                        class="select w-full bg-textbox-fill border border-textbox-border text-support-text inter-400"
                      >
                        @for (option of getDetailsFormQuestionAnswerOptions(formControl.key); track option) {
                          <option [value]="option.guid">{{ option.text }}</option>
                        }
                      </select>
                    }
                    @if (getDetailsFormFieldType(formControl.key) === QuestionType.MultipleChoice) {
                      <select
                        formControlName="{{ formControl.key }}"
                        multiple
                        class="select w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 min-h-[80px]"
                      >
                        @for (option of getDetailsFormQuestionAnswerOptions(formControl.key); track option) {
                          <option [value]="option.guid">{{ option.text }}</option>
                        }
                      </select>
                    }
                  </div>
                }
              </form>
            </div>
          }
        </div>

      </div>

          <div class="panel flex flex-col">

            <div
              class="flex-1 rounded-[10px] border border-textbox-border bg-surface-background p-6 lg:p-8 relative
                     lg:opacity-0 lg:translate-x-3 lg:pointer-events-none
                     lg:transition-all lg:duration-700 lg:ease-[cubic-bezier(0.2,0.8,0.2,1)]"
              [ngClass]="{
                'lg:opacity-100': showRespondentPanel,
                'lg:translate-x-0': showRespondentPanel,
                'lg:pointer-events-auto': showRespondentPanel
              }"
            >
            @if (surveyRespondentType === SurveyRespondentType.Existing) {
              <div class="absolute top-6 right-6 lg:top-8 lg:right-8 flex gap-2">
                @if (!isEditingRespondent()) {
                  <button
                    (click)="startEditingRespondent()"
                    class="px-4 py-2 rounded-full border border-nav-btn-border bg-transparent text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text inter-500 text-sm transition-colors"
                  >
                    Edit
                  </button>
                } @else {
                  <button
                    (click)="cancelEditingRespondent()"
                    class="px-4 py-2 rounded-full border border-base-200 text-base-200 bg-neutral dark:bg-surface-background hover:bg-textbox-fill inter-500 text-sm transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    (click)="saveEditedRespondent()"
                    class="px-4 py-2 rounded-full border border-kek-purple text-white bg-kek-purple hover:bg-purple-700 inter-500 text-sm transition-colors"
                  >
                    Save
                  </button>
                }
              </div>
            }


            <h1 class="space-grotesk-600 text-[27px] text-left mb-6 text-support-text">Respondent Details</h1>

            <form [formGroup]="newRecipientDetailsForm" class="flex flex-col gap-4">
              <!-- First Name / Last Name -->
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                  <label class="inter-400 text-sm mb-1 block text-support-text">First Name</label>
                  <input
                    formControlName="firstName"
                    type="text"
                    class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 read-only:opacity-60 read-only:cursor-not-allowed"
                    placeholder="First Name"
                    [readonly]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                  />
                </div>
                <div>
                  <label class="inter-400 text-sm mb-1 block text-support-text">Last Name</label>
                  <input
                    formControlName="lastName"
                    type="text"
                    class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 read-only:opacity-60 read-only:cursor-not-allowed"
                    placeholder="Last Name"
                    [readonly]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                  />
                </div>
              </div>

              <!-- Email (full width) -->
              <div>
                <label class="inter-400 text-sm mb-1 block text-support-text">Email</label>
                <input
                  formControlName="email"
                  type="email"
                  class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 read-only:opacity-60 read-only:cursor-not-allowed"
                  placeholder="Email"
                  [readonly]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                />
              </div>

              <!-- Date of Birth / Mobile Number -->
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                  <label class="inter-400 text-sm mb-1 block text-support-text">Date of Birth</label>
                  <input
                    formControlName="dateOfBirth"
                    type="date"
                    class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 read-only:opacity-60 read-only:cursor-not-allowed"
                    [readonly]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                  />
                </div>
                <div>
                  <label class="inter-400 text-sm mb-1 block text-support-text">Mobile Number</label>
                  <input
                    formControlName="mobileNumber"
                    type="text"
                    class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 read-only:opacity-60 read-only:cursor-not-allowed"
                    placeholder="Mobile Number"
                    [readonly]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                  />
                </div>
              </div>

              <!-- Ethnicity / Gender -->
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                  <label class="inter-400 text-sm mb-1 block text-support-text">Ethnicity</label>
                  <div class="relative">
                    <button
                      type="button"
                      class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 pr-10 text-left flex items-center justify-between"
                      [class.opacity-60]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                      [class.pointer-events-none]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                      (click)="ethnicityDropdownOpen.set(!ethnicityDropdownOpen())"
                    >
                      <span>{{ getEthnicityLabel() }}</span>
                      <span class="material-symbols-outlined text-base-200">arrow_drop_down</span>
                    </button>
                    @if (ethnicityDropdownOpen() && (surveyRespondentType !== SurveyRespondentType.Existing || isEditingRespondent())) {
                      <ul class="absolute z-10 bg-neutral w-full mt-1 max-h-60 overflow-auto rounded-lg shadow-lg border border-textbox-border">
                        @for (option of Ethnicity | keyvalue: unsorted; track option) {
                          <li
                            class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 flex items-center gap-2 text-support-text"
                            (click)="toggleEthnicity(option.value); $event.stopPropagation()"
                          >
                            <span class="w-5 h-5 rounded border border-textbox-border flex items-center justify-center"
                              [class.bg-kek-purple]="isEthnicitySelected(option.value)"
                              [class.border-kek-purple]="isEthnicitySelected(option.value)">
                              @if (isEthnicitySelected(option.value)) {
                                <span class="material-symbols-outlined text-white text-sm">check</span>
                              }
                            </span>
                            {{ option.value }}
                          </li>
                        }
                        <li class="px-4 py-2 border-t border-textbox-border">
                          <button
                            type="button"
                            class="text-kek-purple inter-500 text-sm"
                            (click)="ethnicityDropdownOpen.set(false)"
                          >
                            Done
                          </button>
                        </li>
                      </ul>
                    }
                  </div>
                  @if (newRecipientDetailsForm.controls.ethnicities.value?.includes(Ethnicity.other)) {
                    <input
                      formControlName="customEthnicity"
                      type="text"
                      placeholder="Other ethnicity"
                      class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 mt-2 read-only:opacity-60 read-only:cursor-not-allowed"
                      [readonly]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                    />
                  }
                </div>
                <div>
                  <label class="inter-400 text-sm mb-1 block text-support-text">Gender</label>
                  <div class="relative">
                    <button
                      type="button"
                      class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 pr-10 text-left flex items-center justify-between"
                      [class.opacity-60]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                      [class.pointer-events-none]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                      (click)="genderDropdownOpen.set(!genderDropdownOpen())"
                    >
                      <span>{{ getGenderLabel() }}</span>
                      <span class="material-symbols-outlined text-base-200">arrow_drop_down</span>
                    </button>
                    @if (genderDropdownOpen() && (surveyRespondentType !== SurveyRespondentType.Existing || isEditingRespondent())) {
                      <ul class="absolute z-10 bg-neutral w-full mt-1 max-h-60 overflow-auto rounded-lg shadow-lg border border-textbox-border">
                        @for (option of Gender | keyvalue: unsorted; track option) {
                          <li
                            class="cursor-pointer px-4 py-3 hover:bg-textbox-fill inter-400 text-support-text"
                            (click)="newRecipientDetailsForm.controls.gender.setValue(option.value); genderDropdownOpen.set(false)"
                          >
                            {{ option.value }}
                          </li>
                        }
                      </ul>
                    }
                  </div>
                  @if (newRecipientDetailsForm.controls.gender.value === Gender.selfDescribe) {
                    <input
                      formControlName="customGender"
                      type="text"
                      placeholder="Other gender"
                      class="input w-full bg-textbox-fill border border-textbox-border text-support-text inter-400 mt-2 read-only:opacity-60 read-only:cursor-not-allowed"
                      [readonly]="surveyRespondentType === SurveyRespondentType.Existing && !isEditingRespondent()"
                    />
                  }
                </div>
              </div>
            </form>

            <!-- Footer: Created / Last Updated (only for existing) -->
            @if (surveyRespondentType === SurveyRespondentType.Existing && existingRespondentGuid) {
              <div class="flex justify-between mt-8 pt-4 border-t border-textbox-border text-sm text-base-200 inter-400">
                <span>Created: {{ getCreatedAtDisplay() }}</span>
                <span>Last Updated: {{ getModifiedAtDisplay() }}</span>
              </div>
            }
          </div>
        </div>
        </div>
      </div>


      <div
        class="button-row mt-8 flex w-full items-center justify-between border-t border-textbox-border pt-6"
        [class.button-row--expanded]="showRespondentPanel"
      >
        <button
          (click)="cancel()"
          [disabled]="sending"
          matRipple
          class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-8 py-3 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-lg transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
        >
          Back
        </button>
        <button
          (click)="initialise()"
          [disabled]="sending || shouldDisableNextButton()"
          matRipple
          class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-8 py-3 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-lg transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
        >
          {{ inviteeEmailAddress || inviteeMobileNumber ? 'Send' : 'Next' }}
        </button>
      </div>

    </div><!-- /outer centering wrapper -->

    @if (sending) {
      <div
        class="fixed inset-0 z-[70] bg-black/20 flex items-center justify-center"
        aria-live="polite"
      >
        <div class="relative">
          <app-short-loading [centered]="true" />
        </div>
      </div>
    }
  </main>
</div>
